import { useState, useCallback } from 'react';
import { message as antdMessage } from 'antd';
import { beautifyConversationMessage } from '../Components/Messages/MessagesServices';

/**
 * Custom hook for managing message beautification
 * Handles AI-powered message enhancement
 */
export const useMessageBeautify = ({ conversationId, t, handleError }) => {
    const [beautifying, setBeautifying] = useState(false);

    const runBeautifyMessage = useCallback(async (textToBeautify) => {
        if (!textToBeautify || !textToBeautify.trim()) {
            return { suggestions: [] };
        }
        if (!conversationId) {
            antdMessage.error(t('no_conversation_selected'));
            return { suggestions: [] };
        }
        setBeautifying(true);
        try {
            const response = await beautifyConversationMessage(conversationId, textToBeautify);
            const root = response?.data || response || {};

            const suggestionsList = Array.isArray(root.suggestions) ? root.suggestions : [];

            if (!suggestionsList.length) {
                antdMessage.info(t('no_suggestions_available'));
                return { suggestions: [] };
            }

            const coinsAmount = root.coins_amount ?? null;
            const analysis = root.analysis || '';
            const warnings = Array.isArray(root.warnings) ? root.warnings : [];

            return {
                suggestions: suggestionsList,
                coinsAmount,
                analysis,
                warnings,
            };
        } catch (error) {
            handleError(error);
            return { suggestions: [] };
        } finally {
            setBeautifying(false);
        }
    }, [conversationId, handleError, t]);

    return {
        beautifying,
        runBeautifyMessage
    };
};
